const internalProtocols = new Set(["data:", "blob:"])

export function getProxiedImageUrl(src?: string | null) {
	if (!src) return undefined
	try {
		const origin =
			typeof window === "undefined"
				? "http://localhost"
				: window.location.origin
		const url = new URL(src, origin)
		if (internalProtocols.has(url.protocol)) return src
		if (url.origin === origin) return `${url.pathname}${url.search}${url.hash}`
		if (url.hostname === "assets.orbit.buape.com") {
			return `/assets${url.pathname}${url.search}`
		}
		const proxyUrl = new URL("/api/image", origin)
		proxyUrl.searchParams.set("url", url.toString())
		return `${proxyUrl.pathname}${proxyUrl.search}`
	} catch {
		return src
	}
}
